module.exports = __webpack_public_path__ + "static/media/honda.2f04ff2c.svg";